import { Button, CircularProgress, Grid, TextField, Typography } from '@material-ui/core';
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import { IReportMovementsProducts } from 'interfaces/reportMovementsProducts';
import { Controller, useForm } from 'react-hook-form';
import esLocale from 'date-fns/locale/es';
import DateFnsUtils from '@date-io/date-fns';
import useProductsIM from 'hooks/useProductsIM';
import { download } from 'utils/downloadXlsx';
import useCustomSnackbar from 'hooks/useCustomSnackbar';
import { useState } from 'react';

export default function ReportMovementsProducts() {
  const { handleSubmit, control, errors, register } = useForm<IReportMovementsProducts>({
    defaultValues: {
      endDate: new Date(),
      initialDate: new Date()
    }
  });
  const [isLoading, setIsLoading] = useState(false);
  const { getXLSX } = useProductsIM();
  const { showNotistack } = useCustomSnackbar();

  const onSubmit = async (data: IReportMovementsProducts) => {
    setIsLoading(true);
    getXLSX(data.sku, data.initialDate, data.endDate)
      .then((result) => {
        if (!result.isError) {
          download(result.base64, 'reporteDeMovimiento');
        } else {
          showNotistack({ message: result.message ? result.message : 'Ocurrio un error' });
        }
      })
      .finally(() => setIsLoading(false));
  };

  const handleKeyPress = (event: { key: string }) => {
    if (event.key === 'Enter') {
      handleSubmit(onSubmit);
    }
  };
  return (
    <Grid container justify="center" spacing={2}>
      <Grid item xs={12}>
        <Typography variant="h5" component="h1" align="center">
          Exportar reporte
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <form noValidate onSubmit={handleSubmit(onSubmit)}>
          <Grid container spacing={1}>
            <Grid item xs={3}>
              <Controller
                control={control}
                name="initialDate"
                rules={{ required: true }}
                render={(props) => {
                  return (
                    <MuiPickersUtilsProvider locale={esLocale} utils={DateFnsUtils}>
                      <KeyboardDatePicker
                        variant="inline"
                        inputVariant="outlined"
                        format="MM/dd/yyyy"
                        margin="dense"
                        onKeyPress={handleKeyPress}
                        fullWidth
                        error={errors.initialDate ? true : false}
                        helperText={errors.initialDate ? 'Este campo es requerido' : ''}
                        label="Fecha Inicial"
                        value={props.value}
                        autoOk={true}
                        onChange={props.onChange}
                      />
                    </MuiPickersUtilsProvider>
                  );
                }}
              />
            </Grid>
            <Grid item xs={3}>
              <Controller
                rules={{ required: true }}
                error={errors.endDate ? true : false}
                control={control}
                name="endDate"
                render={(props) => {
                  return (
                    <MuiPickersUtilsProvider locale={esLocale} utils={DateFnsUtils}>
                      <KeyboardDatePicker
                        variant="inline"
                        format="MM/dd/yyyy"
                        inputVariant="outlined"
                        margin="dense"
                        onKeyPress={handleKeyPress}
                        fullWidth
                        label="Fecha Final"
                        error={errors.endDate ? true : false}
                        helperText={errors.endDate ? 'Este campo es requerido' : ''}
                        value={props.value}
                        onChange={props.onChange}
                        autoOk={true}
                      />
                    </MuiPickersUtilsProvider>
                  );
                }}
              />
            </Grid>
            <Grid item xs={3}>
              <TextField
                variant="outlined"
                margin="dense"
                fullWidth
                label="SKU"
                name="sku"
                autoComplete="sku"
                inputRef={register<HTMLInputElement>({
                  required: false
                })}
                onKeyPress={handleKeyPress}
                // error={errors.sku ? true : false}
                // helperText={errors.sku ? 'Este campo es requerido' : ''}
                InputLabelProps={{ shrink: true }}
              />
            </Grid>
            <Grid item xs={3}>
              <Button disabled={isLoading} type="submit" variant="contained" color="primary" style={{ marginTop: 9 }}>
                {isLoading && (
                  <CircularProgress
                    size={24}
                    style={{ marginRight: 10, width: 16, height: 16, position: 'relative' }}
                  />
                )}
                Descargar
              </Button>
            </Grid>
          </Grid>
        </form>
      </Grid>
    </Grid>
  );
}
